module.exports = __webpack_public_path__ + "static/media/flag-icon.8cc808f4.svg";